package com.trevorwiebe.timesheet.mileage.presentation

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import com.trevorwiebe.timesheet.mileage.domain.model.Location

@Composable
actual fun AddMileageEntryDialog(uiState: MileageUiState, onEvent: (MileageEvent) -> Unit) {
    Dialog(onDismissRequest = { onEvent(MileageEvent.OnDismissAddDialog) }) {
        Card(shape = RoundedCornerShape(16.dp)) {
            Column(modifier = Modifier.padding(vertical = 16.dp)) {
                AddMileageEntryFormContent(uiState = uiState, onEvent = onEvent)
            }
        }
    }
}

@Composable
actual fun LocationSearchDialog(
    locations: List<Location>,
    nameFieldLabel: String,
    initialName: String,
    initialCity: String,
    initialState: String,
    onSelect: (Location) -> Unit,
    onNewLocation: (name: String, city: String, state: String) -> Unit,
    onDismiss: () -> Unit,
    allowNewLocation: Boolean,
    clearLabel: String?,
    onClear: (() -> Unit)?,
) {
    Dialog(
        onDismissRequest = onDismiss,
        properties = DialogProperties(usePlatformDefaultWidth = false)
    ) {
        LocationSearchContent(
            locations = locations,
            nameFieldLabel = nameFieldLabel,
            initialName = initialName,
            initialCity = initialCity,
            initialState = initialState,
            onSelect = onSelect,
            onNewLocation = onNewLocation,
            onDismiss = onDismiss,
            allowNewLocation = allowNewLocation,
            clearLabel = clearLabel,
            onClear = onClear,
        )
    }
}
